const ROOT = 'JOB_TYPES_LIST_';

const actionTypes = {
  LOAD_DATA_REQUEST: `${ROOT}LOAD_DATA_REQUEST`,
  LOAD_DATA_SUCCESS: `${ROOT}LOAD_DATA_SUCCESS`,
  LOAD_DATA_ERROR: `${ROOT}LOAD_DATA_ERROR`,
  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actionTypes;
